<template>
  <div id="commercial-bldg">
    Commercial Building
    Lorem ipsum dolor, sit amet consectetur adipisicing elit. Illum similique labore sapiente impedit rerum voluptatibus! Cumque molestiae aliquam illo sapiente tenetur tempora blanditiis exercitationem quisquam vel, explicabo id excepturi porro.
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
#commercial-bldg{
    height: 300px;
    width: 85%;
    margin: auto;
    text-align: center;
    /* border: 1px solid black; */
}
</style>